export default {
  methods: {
    filterItems(items, text) {
      return _.isEmpty(text)
        ? items
        : _.filter(items, i => _.includes(_.toLower(JSON.stringify(i)), _.toLower(text)));
    }
  }
};
